// extracted by mini-css-extract-plugin
module.exports = {"root":"cA4ag","iframeWrapper":"FOz78","closeButton":"_3V_r5"};